/** sessionStorage key the GitHub callback reads to return an admin to where they started. */
export const GITHUB_RETURN_TO_KEY = "compbox.github.returnTo";

/** Where GitHub's install callback brings an admin back to: the project's repository card. */
export function projectGitHubReturnTo(teamId: string): string {
  return `/teams/${teamId}?tab=settings&connect=github`;
}
